import { useEffect, useState } from "react";
import { MdCancel } from "react-icons/md";
const SelectMultiple = (props) => {
  const [value, setValue] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [option, setOption] = useState([]);
  const [optionsStyle, setOptionsStyle] = useState(false);

  useEffect(() => {
    setOption(props.item.options);
    document.body.addEventListener("click", (event) => {
      if (!event.target.matches(".matches-option")) setOptionsStyle(false);
    });
    if (props.pageType === "edit") {
      const object2 = props.editDataValue.map((item2) => {
        const object = props.item.options.filter((item) => {
          return item.value === item2;
        });
        return object[0];
      });
      setSelectedOptions(object2);
    }
  }, []);

  function onChange(event) {
    setValue(event.target.value);
    const array = props.item.options.filter((item) => {
      return item.label.search(`${event.target.value}`) !== -1;
    });
    setOption(array);
  }

  function selectOption(event) {
    let array = selectedOptions;
    if (
      array.find((item) => {
        return item.label === event.target.getAttribute("label");
      }) === undefined
    ) {
      array.push({
        label: event.target.getAttribute("label"),
        value: Number(event.target.getAttribute("id"))
          ? Number(event.target.getAttribute("id"))
          : event.target.getAttribute("id"),
      });
    }
    setSelectedOptions(array);
    setValue("");
    setPropsInputData(
      array.map((item) => {
        return item.value;
      }),
    );
    setOptionsStyle(false);
  }

  function deleteOption(event) {
    let array = selectedOptions;
    let array2 = array.filter((item) => {
      // console.log(item.value, "=", event.currentTarget.id, "skdjfjjejooo");
      // return +item.value !== +event.currentTarget.id;
      if (!+item.value) {
        return item.value !== event.currentTarget.id;
      } else {
        return +item.value !== +event.currentTarget.id;
      }
    });
    setSelectedOptions(array2);
    setPropsInputData(
      array2.map((item) => {
        return item.value;
      }),
    );
  }

  function setPropsInputData(array) {
    if (props.HasManyInputData) {
      props.HasManyInputData(props.index, props.HasManyKey, array);
    } else {
      let object = props.inputData;
      object[props.item.key] = array;
      props.setInputData(object);
    }
  }

  return (
    <div>
      <div className="w-full rounded-md col-span-full sm:col-auto z-50">
        <input
          className={`h-[38px] dark:bg-[#ffffffdd] border border-edit_input_border ${props.item.disabled ? "text-edit_input_text" : "edit_input_text_disabled"} dark:text-[#555555] rounded-[4px] px-3 w-full matches-option`}
          value={value}
          onChange={onChange}
          onFocus={() => {
            setOptionsStyle(true);
          }}
          disabled={props.item.disabled}
        />
        {optionsStyle && (
          <ul className="w-full bg-white max-h-[200px] overflow-y-scroll border border-edit_input_border shadow-xl">
            {option.length > 0 &&
              option.map((item) => (
                <li
                  id={item.value}
                  label={item.label}
                  className="w-full py-[5px] px-[10px] matches-option hover:bg-[#9cc8cae1]"
                  onClick={selectOption}
                >
                  {item.label}
                </li>
              ))}
          </ul>
        )}
      </div>
      <div className="h-38 mt-1 flex items-center justify-end flex-wrap gap-2 pt-[4px] px-1 w-fit">
        {selectedOptions.map((item) => (
          <div className="bg-[#9cc8cae1] w-fit px-[8px] rounded-xl h-[30px] flex items-center gap-1">
            <span className="text-[#242424]">{item.label}</span>
            <button type="button" onClick={deleteOption} id={item.value}>
              <MdCancel className="text-stone-600" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectMultiple;
